import { isBoardControllerRefactorEnabled } from 'app/src/components/Board/isBoardControllerRefactorEnabled';
import { isBoardCanvasModernizationEnabled } from 'app/src/isBoardCanvasModernizationEnabled';

export const logBoardCanvasPerformanceMessage = (
  ...args: Parameters<typeof console.log>
) => {
  if (
    isBoardCanvasModernizationEnabled() ||
    isBoardControllerRefactorEnabled()
  ) {
    // eslint-disable-next-line no-console
    console.log('## BOARD CANVAS PERFORMANCE MESSAGE:', ...args);
  }
};
